import { collectionScope, Currency } from '@nemuru-eng/js-api-client';
import { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

import { MetricsControllers } from '@/components/modules/Metrics/ChannelAgentMetricViews/components/MetricsControllers';
import { loanStatusExternalValues } from '@/components/modules/Metrics/ChannelAgentMetricViews/constants/LoanStatusExternalValues';
import { MerchantChannelAgentMetricViews } from '@/components/modules/Metrics/shared/components/MerchantChannelAgentMetricViews';
import { useLiveMetrics } from '@/components/modules/Metrics/shared/hooks/useLiveMetrics';
import { useMetricMerchantChannelAgentViews } from '@/components/modules/Metrics/shared/hooks/useMetricMerchantChannelAgentViews';
import { useMetricsScope } from '@/components/modules/Metrics/shared/hooks/useMetricsScope';
import { useTimeInterval } from '@/components/modules/Metrics/shared/hooks/useTimeInterval';
import { ScoreCardMetricKey } from '@/components/modules/Metrics/shared/types/ScoreCardMetricKey';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

export const MetricAgentViews = () => {
  const { timeInterval, setTimeInterval } = useTimeInterval();
  const [selectedMetricsType, setSelectedMetricsType] = useState<ScoreCardMetricKey>(
    ScoreCardMetricKey.totalPrincipalAmount,
  );

  const { merchantId, channelId, agentId } = useParams();

  const routeScope = useMemo(() => {
    if (!agentId) return undefined;
    try {
      return collectionScope.agent(agentId);
    } catch {
      return undefined;
    }
  }, [agentId]);
  useLiveMetrics(useMetricsScope(routeScope));

  if (!merchantId) return null;

  const currency = Currency.EUR;

  const { filteredMetrics, hasRequested } = useMetricMerchantChannelAgentViews({
    currency,
    timeInterval,
    loanStatusExternal: loanStatusExternalValues,
    merchantIds: [merchantId],
    channelId,
    agentId,
  });

  if (!timeInterval) {
    return null;
  }

  return (
    <>
      <MetricsControllers
        selectedMetricsType={selectedMetricsType}
        setSelectedMetricsType={setSelectedMetricsType}
        timeInterval={timeInterval}
        setTimeInterval={setTimeInterval}
      />
      <MerchantChannelAgentMetricViews
        currency={Currency.EUR}
        selectedMetricsType={selectedMetricsType}
        timeInterval={timeInterval}
        loanStatusExternal={loanStatusExternalValues}
        filteredMetrics={filteredMetrics}
        hasRequested={hasRequested}
      />
    </>
  );
};

export const MetricsAgentViewsModule = withPermissionsModule(MetricAgentViews);
